/*
 * @Description: Description
 * @Author: zhaoqianqian
 * @Date: 2021-10-29 13:58:43
 * @LastEditors: 欧亚平 18682930953@163.com
 * @LastEditTime: 2026-09-20 14:22:23
 */
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import agrZh from './agr-zh' 
export default {
    // ai报告相关
    ai: {
        report: "AI报告解读",
        train: "训练大纲",
        loading: "加载中，请稍等… ",
        loadingError1: "报告加载失败",
        loadingError2: "很抱歉给您带来不便，请稍后重试",
    },
    // 登录页面
    login: {
        loginAndRegister: '注册/登录',
        registerAndLogin: '登录/注册',
        userLogin: '用户登录',
        title: '手机账号和邮箱账号互相独立，请注意您的账号类型。',
        mobileLogin: '手机',
        emailLogin: '邮箱',
        email: 'E-mail',
        loginBtn: '登录',
        autoLogin: '下次自动登录',
        retransmission: '{item}秒后重发',
        formList: [
            {
                label: '请输入手机号码',
                placeholder: '获取验证码',
            },
            {
                label: '验证码',
                placeholder: '请输入验证码',
            },
            {
                label: '请输入邮箱',
            },
        ],
        btn: {
            submit: '创建新账号',
            title: '真实的信息非常重要，请仔细填写',
        },
        rule: {
            phone: {
                requiredMsg: '手机号格式不正确',
                patternMsg: '手机号未注册，请创建新账号',
            },
            authCode: {
                requiredMsg: '验证码错误，请重新填写',
            },
            email: {
                requiredMsg: '邮箱格式不正确',
                patternMsg: '邮箱未注册，请创建新账号',
            },
        },
        codeSuccess: '验证码已发送，请查收',
        success: '发送成功',
        error: '发送失败',
        loginSuccess: '登录成功',
        account: {
            accountTitle: '登录',
            registerTitle: '注册',
            resetTitle: '设置密码',
            password: '密码',
            placeholder: '请输入密码',
            codeLogin: '验证码登录',
            accountLogin: '使用密码登录',
            forgotPassword: '忘记密码?',
            registerTips:[
                '还没有账号?', 
                '注册', 
                '账号已存在',
                '立即注册',
            ],
            checkRule: [
                '8-20 个字符',
                '至少包含一个大写字母',
                '至少包含一个小写字母',
                '至少包含一个数字', 
                '密码不一致'
            ],
            errorTips: [
                '密码错误', 
                '登录失败', 
                '账号不存在'
            ],
            reset:[
                '重置密码', 
                "下一步",
                '新密码不能与上一次的密码相同', 
                '跳过',
                '密码设置成功'
            ],
            setPasswordTips:'密码由 8-20 个字符组成，须包含大写字母、小写字母和数字。',
            confirmPassword: "确认密码",
        },
        switchButton: '密码登录',
        switchButton1: '验证码登录',
        loginTips: '未注册的账号登录成功将自动注册',
        otherLogin: '其他登录方式',
        newEmailLogin: '邮箱登录',
        newPhoneLogin: '手机号登录',
        bindLineTips:'或',
        bindEmail: '绑定邮箱登录',
        bindPhone: '绑定手机号登录',
        bindAndContinue: "绑定并继续",
        bind: "绑定",
        bindEmailTitle: '绑定邮箱',
        bindEmailTips1: "未获取到您的 {item} 邮箱信息 ",
        bindEmailTips2: "请绑定邮箱以继续使用账号",
        bindEmailTips3: "您的账号尚未绑定邮箱，绑定后可通过邮箱登录并找回密码",
        boundTitle: '您之前是否注册过？',
        boundCenterTitle1:'如果您是新用户',
        boundCenterTips1:'可以直接创建账号并开始使用',
        boundCenterTitle2:'如果您之前注册过账号',
        boundCenterTips2:'可以绑定已有账号以同步历史数据',
        boundCenterTips3:'请绑定已注册的账号',
        boundCenterTips4:'推荐',
        boundCenterTips5:'将 {item} 账号绑定到已有账号',
        boundCenterTips6:'绑定后，历史测量数据和报告会自动同步',
        boundButton1: '使用 {item} 创建账号',
        boundButton2: '绑定已有账号',
        phoneCode:"手机验证码登录",
        phonePassword:"手机密码登录",
        emailCode:"邮箱验证码登录",
        emailPassword:"邮箱密码登录",
        thirdAccountAlreadyRegistered: '该账号已注册，请重新登录', // 第三方账号重复注册提示。
        accountDoesNotExist:"该账号尚未注册，请使用邮箱验证码或 {item} 登录完成注册",
        toRegister:"去注册",
        bindNow: "立即绑定",
        bindError:[
            '绑定失败',
            '解绑成功',
            '解绑失败',
            '授权失败',
            '授权失败,无法获取账号信息',
            '绑定成功',
            '账号不存在，请绑定已注册账号',
            '绑定失败,该账号已绑定{item}账号 [{nickname}]',
            '已授权注册为账号，不支持解绑',
            '账号不存在，请使用验证码登录并注册',
        ],
        accountSecurity: {
            faceBook:'Facebook 账号',
            google: 'Google 账号',
            isBind: '未绑定',
            dialogTitle: '确定解绑？',
            dialogCenter: '解绑 {item} 后将无法继续使用它登录该账号',
            bindFailure:'绑定失败',
            bindFailureTips: '您的 {item} 账号已被下方账号绑定，如需换绑至当前账号，请先登录下方账号解除绑定',
            returnButton:'确认并返回'
        },
        bindEmailError: [
            "邮箱已存在，请更换邮箱。"
        ],

    },
    // 注册页面
    register: {
        mobileRegister: '手机注册',
        emailRegister: '邮箱注册',
        enroll: '手机号已注册',
        enrollEmail: '邮箱已注册',
        search: '搜索',
        title: '手机账号和邮箱账号互相独立，请注意您的账号类型。',
        needRead: {
            agree: '我已阅读并同意',
            privacy: '《用户隐私协议》',
        },
        register: '注册',
        check: '勾选“用户隐私协议”',
        newUser: '新用户注册',
        form: {
            labelList: ['姓名', '* 性别', '* 身高', '* 年龄'],
        },
        placeholder: ['请输入姓名', '请输入你的身高', '请输入你的年龄'],
        unit: ['公制', '英制', '岁'],
        sexOptions: {
            male: '男',
            female: '女',
        },
        btn: '提交',
        rules: {
            metricheight: ['允许测量的身高范围是 2ft3in-6ft7in，请重新输入'],
            heightMsg: ['允许测量的身高范围是 70-200cm，请重新输入'],
            ageMsg: ['允许测量的年龄范围 10-99岁，请重新输入'],
            agePointMsg: ['填写了非整数：年龄只能为整数，请填写正确的年龄'],
        },
        success: '注册成功',
        userMessage: '请输入用户名',
        verify: '请输入4位数的验证码',
        errorMsg: '允许输入的身高格式不支持小数，请重新输入',
        abnormalMsg: '注册异常',
    },
    // 模型合成
    model: {
        loading: '模型生成中，请您稍候',
        modelLoading: '模型加载中...',
        tabPane: [
            {
                title: '深度实感技术',
                msg: '通过三维扫描准确采集身体局部细节，保证围度测量的毫米级精度，让健身后的体型变化清晰呈现。',
            },
            {
                title: 'BDA 体成分算法',
                msg: '维塑采用最前沿的人体成分测算体系--BDA 算法确定人体成分，这项基于身体体积的测算方式将更精确地评估肥胖带来的健康风险。',
            },
            {
                title: '误差产生因素',
                msg: '宽松的着装、身上的异物等都会导致不同程度的误差，如您想获取最精确的数据，请您穿着紧身衣或减少身上的衣物。',
            },
            {
                title: '报告入口',
                msg: '建议收藏网页，方便日后查看报告。稍后您也可将此报告发送至邮箱保存。',
            },
        ],
        collect: ['请收藏本网页，', '方便日后查看报告。'],
        know: '我知道了',
        reminder: [
            '温馨提示',
            '您的三维模型已生成，可尝试左右滑动来旋转模型。',
            '您的报告已生成，可点击“查看报告”按钮查看。',
            '您的体态评估未成功，请查看体成分报告。',
            '您的身体成分未成功，请查看体态评估报告。',
            '您的测量未成功，请到设备端重新体验哦~',
            '身体成分未成功，请到设备端重新体验哦~',
            '体态评估未成功，请到设备端重新体验哦~',
        ],
        btn: {
            viewReport: '查看报告',
            bodyReport: '查看体成分报告',
            postureReport: '查看体态报告',
            lastReport: '查看上次报告',
            loading: '加载中...',
        },
    },
    // 报告
    report: {
        btn: {
            download: '下载报告',
            send: '发送报告',
            report: '报告',
        },
        reportSuccess: '报告生成成功',
        tabPane: {
            labelList: ['测量时间', '测量项目', '身体成分', '体态评估', '肩部功能'],
        },
        sendEmail: '发送至邮箱:',
        requiredMsg: '请输入你的邮箱地址',
        patternMsg: '请输入正确的邮箱',
        send: '发送',
        download: '下载报告',
        sendReport: '发送报告',
    },
    // 侧边栏
    sidebar: {
        successMsg: {
            sex: '性别修改成功',
            height: '身高修改成功',
            age: '年龄修改成功',
        },
        logOut: '退出登录',
        personal: '个人中心',
        cut: '切换单位/语言',
        changeSort: '切换产品报告',
        setPassword: '设置/修改密码',
        accountSecurity: '账号与安全',
        describe: '* 切换产品型号后，将为您展示对应产品型号下的所有测量报告。',
        describeBtn: '产品型号切换后，将为您跳转到该产品型号下的最新测量报告。',
        descReport: '产品报告切换成功',
        unit: ['公制 (kg, cm)', '英制 (ft, in, lb)'],
        read: {
            reading: '阅读',
            privacy: '《用户隐私协议》',
        },
        setting: '设置',
        form: {
            labelList: ['手机号码', '单位', '语言', '昵称', '性别', '身高', '年龄'],
        },
        placeholder: ['修改昵称', '性别修改', '身高修改', '年龄修改'],
        btn: {
            cancelBtn: '取消',
            accomplishBtn: '完成',
            confirmBtn: '确定',
        },
        dialog: [
            '性别是体成分测量的重要依据之一，修改后测量的数据会与以往数据出现差异，请确认是否修改？',
            '身高是体成分测量的重要依据之一，修改后测量的数据会与以往数据出现差异，请确认是否修改？',
            '年龄是体成分测量的重要依据之一，修改后测量的数据会与以往数据出现差异，请确认是否修改？',
        ],
        rules: {
            metricheight: ['请填写范围内身高（2ft3in-6ft7in）'],
            heightMsg: ['请填写范围内身高（70-200cm）'],
            ageMsg: ['请填写范围内年龄（10-99岁）', '填写了非整数：年龄只能为整数，请填写正确的年龄'],
        },
        heightMsg: '请重新选择身高',
        ageMsg: '请重新选择年龄',
        ModelBinding: '好像有人捷足先登扫码了呢，请重新测量吧！',
        ReportEmpty: {
            title: '您还没有相关检测报告',
            desc: '找到 Visbody 3D 体测精灵，进行一次测量吧！',
        },
    },
    // 无测量报告
    modelBinding: {
        desc: '好像有人捷足先登扫码了呢，请重新测量吧！',
    },
    // 扫码模型已被绑定
    reportEmpty: {
        title: '您还没有相关检测报告',
        desc: '找到 Visbody 3D 体测精灵，进行一次测量吧!',
        descS30: '找到 Visbody-S30 3D 体测精灵，进行一次测量吧！',
        descM30: '找到 Visbody-M30 3D 体测精灵，进行一次测量吧！',
    },
    // 用户信息
    userInfo: {
        height: '身高:',
        age: '年龄:',
        unit: '岁',
        weight: '体重',
    },
    // 体成分
    mass: {
        title: '体成分评估总览',
        titles: '身体成分',
        springFrame: '',
        massFrame: '暂无当天测量数据',
        contrast: '选一份报告对比',
        contrastReport: '选择一份对比报告',
        noRecord: '无记录',
        score: '分',
        status: '您目前的体成分状况',
        WT: '体重',
        PBF: '体脂率',
        endSymbol: '。',
        // 测量相关
        measure: {
            value: '测量值',
            standardRange: '标准范围',
            comparedWithLastLime: '对比上次',
            comparedNet: '对比上次',
            current: '本次测量分数',
            WT: '体重',
            FFM: '去脂体重',
            BFM: '体脂肪',
            LM: '肌肉量',
            TBW: '总水分',
            SM: '骨骼肌',
            PROTEIN: '蛋白质',
            TM: '无机盐',
            BMR: '基础代谢',
            WHR: '腰臀比',
            BMI: 'BMI',
            PBF: '体脂率',
            VFG: '内脏脂肪等级',
            unit: 'kg',
            BMRUnit: 'kcal/d',
        },
        // 定义解读
        explain: [
            {
                title: '体重',
                msg: '体重是身体水分、蛋白质、无机盐和体脂肪的总和。',
            },
            {
                title: '去脂体重',
                msg: '去脂体重是体重扣除脂肪的部分。',
            },
            {
                title: '体脂肪',
                msg: '体脂肪是皮下脂肪，内脏脂肪和肌肉之间脂肪的总和。',
            },
            {
                title: '肌肉量',
                msg: '肌肉量是人体的瘦组织群，包括了骨骼肌、平滑肌和心肌。',
            },
            {
                title: '总水分',
                msg: '身体水分在人体成分中占的含量最多，占体重的50%~70%，身体水分分布于人体细胞和体液中，其中大部分存在于肌肉细胞中。',
            },
            {
                title: '骨骼肌',
                msg: '骨骼肌又称横纹肌，附着在骨骼上的肌肉，肌肉中的一种，此处计算的是骨骼肌的含量。',
            },
            {
                title: '蛋白质',
                msg: '蛋白质是含氮的固态物质，存在于人体所有细胞内，参与细胞构成。是肌肉量的主要成分。',
            },
            {
                title: '无机盐',
                msg: '人体是由有机物、无机物和水组成的，人体里的无机物叫无机盐，无机盐大约占人体重量的5%。',
            },
            {
                title: '基础代谢',
                msg: '基础代谢指人体在清醒而安静的状况下，不受运动、食物、神经紧张、外界温度变化等影响时一天消耗的总能量。',
            },
            {
                title: '腰臀比',
                msg: '腰臀比是腰围和臀围的比值，是判定中心性肥胖的重要指标。',
            },
            {
                title: 'BMI',
                msg: 'BMI主要用于评估外观肥胖度，国际上常作为衡量人体胖瘦程度的标准。',
            },
            {
                title: '体脂率',
                msg: '体脂肪率是指体脂肪占体重的比率。',
            },
            {
                title: '内脏脂肪等级',
                msg: '内脏脂肪等级是评价是否属于隐性肥胖的重要指标。',
            },
            {
                title: '细胞内液',
                msg: '细胞内液：是肌体细胞总体所含的体液，是原生质的基本组成部分。',
            },
            {
                title: '细胞外液',
                msg: '细胞外液：通常指为与细胞外的体液，包括血浆以及介于血管和组织细胞之间的组织间液。',
            },
            {
                title: '代谢年龄',
                msg: '代谢年龄是指身体及其健康相关的代谢功能的表现',
            },
            {
                title: '细胞外液比率',
                msg: '细胞外液比率是指细胞外液（ECW）在全身总水分（TBW）中所占的比例，俗称水肿系数，是评估人体体液平衡状态的重要指标。',
            },
        ],
        // 节段
        segment: {
            fat: '节段脂肪',
            muscle: '节段肌肉',
            right: '右',
            left: '左',
            standard: '标准',
            lowStandard: '低标准',
            superStandard: '高标准',
            peel: '(去皮)',
        },
    },
    // 体态
    shape: {
        title: '体态评估总览',
        titles: '体态评估',
        status: '您目前的体态状况',
        suggest: '建议',
        possibility: '，存在',
        models: {
            front: '正面',
            left: '左侧面',
            right: '右侧面',
            top: '背面',
            low: '偏低',
            high: '偏高',
            normal: '正常',
        },
        item: {
            deviate: '测量值',
            result: '说明',
            normal: '正常',
            abnormal: '异常',
			keAbnormal: '可能异常',
            head: '头前引',
            headSlant: '头侧歪',
            roundShoulderLeft: '左圆肩',
            roundShoulderRight: '右圆肩',
            highLowShoudler: '高低肩',
            pelvis: '骨盆前/后移',
            leftKneeCheck: '左膝评估',
            rightKneeCheck: '右膝评估',
            leg: '腿型',
            leftLeg: '左腿：',
            rightLeg: '右腿：',
        },
        // 定义解读
        explain: [
            {
                title: '头前引',
                msg: '左侧面耳朵点与脖子中心连线和侧面中位线的夹角',
            },
            {
                title: '头侧歪',
                msg: '正面头部中点与脖子中心连线和正面中位线的夹角',
            },
            {
                title: '左圆肩',
                msg: '背部左侧最高点连线和肩部切线的夹角',
            },
            {
                title: '右圆肩',
                msg: '背部右侧最高点连线和肩部切线的夹角',
            },
            {
                title: '高低肩',
                msg: '背面左右肩峰点垂直方向的距离',
            },
            {
                title: '骨盆前/后移',
                msg: '左侧面脖子中心点、髋骨点、脚踝三点连线的夹角',
            },
            {
                title: '左膝评估',
                msg: '左侧面髖骨点、膝关节、脚踝点三点连线的夹角',
            },
            {
                title: '右膝评估',
                msg: '右侧面髖骨点、膝关节、脚踝点三点连线的夹角',
            },
            {
                title: '腿型',
                msg: '左右腿正面髋骨骼点、膝关节、脚踝点连线的夹角',
            },
            {
                title: '骨盆前/后倾',
                msg: '左右髂前上棘点和耻骨联合处形成倒三角面，三角面与地面的垂线的夹角'
            },
            {
                title: '长短腿',
                msg: '背面对比两侧臀线最低点到地面的高度差'
            }
        ],
        exception: [
            {
                title: '偏左',
                abnormal: '',
            },
            {
                title: '偏右',
                abnormal: '',
            },
            {
                title: '左高',
                abnormal: '',
            },
            {
                title: '右高',
                abnormal: '',
            },
            {
                title: '骨盆后移',
                abnormal: '',
            },
            {
                title: '骨盆前移',
                abnormal: '',
            },
            {
                title: '左膝超伸',
                abnormal: '',
            },
            {
                title: '左膝前屈',
                abnormal: '',
            },
            {
                title: '右膝超伸',
                abnormal: '',
            },
            {
                title: '右膝前屈',
                abnormal: '',
            },
            {
                title: 'K型腿',
                abnormal: '',
            },
            {
                title: 'D型腿',
                abnormal: '',
            },
            {
                title: 'X型腿',
                abnormal: '',
            },
            {
                title: 'O型腿',
                abnormal: '',
            },
            {
                title: '骨盆前倾',
                abnormal: ''
            },
            {
                title: '骨盆后倾',
                abnormal: ''
            },
            {
                title: '左长异常',
                abnormal: ''
            },
            {
                title: '右长异常',
                abnormal: ''
            }
        ],
    },
    newshape: {
        explain: [
            {
                msg: '耳朵与人体重力线之间的垂直距离',
            },
            {
                msg: '左右耳朵的连线与水平线之间的角度',
            },
            {
                msg: '左肩峰位置与重力线的垂直距离',
            },
            {
                msg: '右肩峰位置与重力线的垂直距离',
            },
            {
                msg: '两侧颈根与肩峰连线的差值',
            },
            {
                msg: '髋关节与人体重力线之间的垂直距离',
            },
            {
                msg: '矢状面上，踝关节、左膝关节下1cm和髋关节的夹角',
            },
            {
                msg: '矢状面上，踝关节、右膝关节下1cm和髋关节的夹角',
            },
            {
                msg: '冠状面上，左右髋关节、膝关节以及踝关节之间的夹角',
            },
        ],
        item: {
            pelvis: '骨盆前移',
        },
    },
    // 围度信息
    girth: {
        title: '身体围度',
        present: '(本次)',
        noHistory: '无数据',
        tpl: [
            {
                title: '颈围',
                key: 'neckGirth',
            },
            {
                title: '左上臂围',
                key: 'leftUpperArmGirth',
            },
            {
                title: '右上臂围',
                key: 'rightUpperArmGirth',
            },
            {
                title: '胸围',
                key: 'bustGirth',
            },
            {
                title: '高腰围',
                key: 'waistGirth',
            },
            {
                title: '中腰围',
                key: 'midWaistGirth',
            },
            {
                title: '臀围',
                key: 'hipGirth',
            },
            {
                title: '左大腿围',
                key: 'leftThighGirth',
            },
            {
                title: '左大腿中部围',
                key: 'leftMidThighGirth',
            },
            {
                title: '左大腿最小围',
                key: 'leftMinThighGirth',
            },
            {
                title: '右大腿围',
                key: 'rightThighGirth',
            },
            {
                title: '右大腿中部围',
                key: 'rightMidThighGirth',
            },
            {
                title: '右大腿最小围',
                key: 'rightMinThighGirth',
            },
            {
                title: '左小腿围',
                key: 'leftCalfGirth',
            },
            {
                title: '右小腿围',
                key: 'rightCalfGirth',
            },
            {
                title: '低腰围',
                key: 'lowWaistGirth',
            },
        ],
    },
    // 肩部
    shoulder: {
        title: '肩部功能',
        model: {
            val: '测量值',
            scope: '最大活动位置',
            diff: '对比上次',
        },
        normal: '暂未发现明显异常',
        normalAll: '肩部功能暂未发现明显异常',
        conclusion: '结论',
        analyse: '分析: ',
        suggest: '建议: ',
        cause: '具体原因请找专业人士做进一步筛查。',
    },
    reportTips: {
        title: "确定删除这份报告吗？删除后无法恢复。",
        confirm: "删除",
        success: "报告已删除",
        partial: "报告已删除，部分数据同步失败，请联系管理员",
        failed: "删除失败，请稍后重试",
        btnMsg: 'OK',
        alaryTips: '该测量报告已被管理员删除，即将跳转下一份报告！',
    },
    saveQr: {
        title: 'Visbody 3D体测报告',
        btnMsg: '长按图片保存到手机',
        tips: '如发现无法保存，请去【设置】打开相应权限',
    },
    share: {
        title: '请复制下方的链接后分享',
        btnMsg: '复制',
    },
	'bodyPrediction': {
		'body-title': '体型预测',
		'body-yu-ce-status': '根据您当前状态预测',
		'body-setting': '体型预测设置',
		'body-li-xiang': '理想值：',
		'body-ti-zhong': '体重',
		'body-ti-zhi-lv': '体脂率',
		'body-ji-rou': '肌肉含量',
		'yu-che-pre': '预测前',
		'yu-che-after': '预测后',
		'zan-model-no': '暂无模型',
		'ti-xing-error': '体型预测结果合成失败~',
		'ti-xing-worker-error': '小编猜测可能是网络原因导致的~',
		'ti-xing-adjust': '调节量',
		'ji-rou-title': '肌肉量',
		'ti-zi-fang': '体脂肪',
		'dang-pre-zhi': '当前值：',
		'nen-zhang': '内脏脂肪等级',
		'nen-zhang-title': '内脏脂肪面积说明',
		'nen-zhang-title1': '内脏脂肪分布在内脏器官之间得脂肪，易导致腹部肥胖，内脏脂肪面积显示的是内脏脂肪横截面积。'
	},
    ...zhLocale,
    ...agrZh,
    wifi: {
        'title': 'WiFi配置',
        'tips': '请输入以下 WiFi 网络的密码',
        'password':'WIFI 密码',
        'password-placeholder': '请输入 WiFi 密码',
        'password-tips': '密码区分大小写，请确保输入正确',
        'button': '生成二维码',
        'h5-title': '配置WIFI信息',
        'wifi-name': 'WIFI名称:',
        'wifi-password': 'WIFI密码:',
        'wifi-qr-tips1': '* 请确认 WiFi 名称和密码无误后，对准设备屏幕下方的相机位置进行扫描。',
        'wifi-qr-tips2': '请将 WiFi 二维码对准屏幕下方的相机位置进行扫描。',
        'wifi-qr-button': '返回',
    },
    "waist": {
    "title": "腰腹围度",
    "hou": "后",
    "qian": "前"
  },
  "yao_wei_1": "腰部",
  "yao_bu_fen_shu": "腰部分数",
  "waist_fen": "分",
  "yao_wei": "腰围",
  "yao_wei_jian_ti_ji": "腰围间体积",
  "yao_tun_bi": "腰臀比",
  "lun_kuo_fen_xi": "轮廓分析",
  "bei_bu": "背部",
  "tunbu": "臀部",
  "bei_bu_ti_ji": "背部体积",
  "zheng_chang_fan_wei": "正常范围：",
  "shang_ci": "上次 ",
  "ben_ci": "本次 ",
  "gupen": {
    "zheng_chang": "正常",
    "qian_qin_yan_chang": "前倾异常",
    "qian_qin_yi": "前倾风险",
    "hou_qin_yi": "后倾风险",
    "hou_qin_yan_chang": "后倾异常",
    "zuo_chang_yan_chang": "左长异常",
    "zuo_chang_yi": "左长风险",
    "you_chang_yi": "右长风险",
    "you_chang_yan_chang": "右长异常"
  },
  "gao_yao_xian": "高腰围",
  "gao_yao_zhong_xian": "高腰中线",
  "gao_yao_xia_xian": "高腰下线",
  "xiao_yao_shang_xian": "低腰上线",
  "xiao_yao_zhong_xian": "低腰中线",
  "xiao_yao_xian": "低腰围",
  "qv_jian1": "高腰上段",
  "qv_jian2": "高腰下段",
  "qv_jian_zhong": "中腰部",
  "qv_jian3": "低腰上段",
  "qv_jian4": "低腰下段",
  "celiang.failed": "测量未成功，请穿紧身衣服并保持静止进行测量",
    "jie-gou-yi-chang-ping-gu": "结构异常评估",
  "teng-tong-feng-xian-ping-gu": "疼痛风险评估",
  "zheng-chang": "正常",
  "qing-du-yi-chang": "轻度异常",
  "zhong-du2-yi-chang": "中度异常",
  "zhong-du-yi-chang": "重度异常",
  "pen-gu-zhuan-xiang-feng-xian-ping-gu": "骨盆专项风险评估",
  "qian-qing": "前倾",
  "hou-qing": "后倾",
  "xuan-zhuan": "旋转",
  "pen-gu-qian-qing-feng-xian-fen-shu": "骨盆前倾风险分数",
  "pen-gu-hou-qing-feng-xian-fen-shu": "骨盆后倾风险分数",
  "pen-gu-xuan-zhuan-feng-xian-fen-shu": "骨盆旋转风险分数",
  "fen": "分",
  "gao-feng-xian": "高风险",
  "ji-rou-ping-gu-jie-guo": "肌肉评估结果",
  "qian-qing-feng-xian-gao": "前倾风险高",
  "hou-qing-feng-xian-gao": "后倾风险高",
  "xuan-zhuan-feng-xian-gao": "旋转风险高",
  "qia-yao-ji-shu-ji-ji-xia-bu-jin-zhang-fu-heng-ji-bao-ruo": "髂腰肌/竖脊肌下部紧张 、腹横肌薄弱",
  "gu-hou-ji-qun-tun-ji-shu-ji-ji-jin-zhang-qia-yao-ji-ruo": "股后肌群、臀肌、竖脊肌紧张、髂腰肌弱",
  "dan-ce-tun-zhong-ji-bao-ruo-yao-fang-ji-bu-ping-heng": "单侧臀中肌薄弱 / 腰方肌不平衡",
  "gu-pen-xiang-guan-ji-rou-ping-gu-zheng-chang-qing-ji-xu-bao-chi-liang-hao-de-sheng-huo-xi-guan": "骨盆相关肌肉评估正常，请继续保持良好的生活习惯。",
  "yi-shang-xiang-mu-jun-zheng-chang": "以上项目均正常",
  "ji-zhu-jie-gou-yi-chang-ping-gu": "脊柱结构异常评估",
  "zheng-ti-ping-fen": "整体评分",
  "jing-zhui": "颈椎",
  "xiong-zhui": "胸椎",
  "yao-zhui": "腰椎",
  "jing-zhui-jie-gou-yi-chang-ping-fen": "颈椎结构异常评分",
  "xiong-zhui-jie-gou-yi-chang-ping-fen": "胸椎结构异常评分",
  "yao-zhui-jie-gou-yi-chang-ping-fen": "腰椎结构异常评分",
  "jing-zhui-ji-rou-ping-gu": "颈椎肌肉评估",
  "xiong-zhui-ji-rou-ping-gu": "胸椎肌肉评估",
  "yao-zhui-ji-rou-ping-gu": "腰椎肌肉评估",
  "ji-zhu-zheng-ti-pai-lie-ji-ben-zheng-chang": "脊柱整体排列基本正常",
  "tou-bu-zi-tai-he-jing-zhui-pai-lie-ji-ben-zheng-chang": "头部姿态和颈椎排列基本正常",
  "cun-zai-ming-xian-de-tou-bu-qian-qing-huo-ce-wai-jing-zhui-pai-lie-qing-du-pian-yi": "头部前倾或侧歪趋势较为明显，颈椎排列略有偏移趋势，建议注意日常坐姿。",
  "tou-bu-ming-xian-qian-qing-huo-ce-wai-jing-zhui-pai-lie-zhong-du-pian-yi": "头部前倾或侧歪趋势较为明显，颈椎排列存在一定偏移，建议进行针对性姿势管理与肌肉训练。",
  "tou-bu-yan-zhong-qian-qing-huo-ce-wai-jing-zhui-pai-lie-yan-zhong-pian-yi": "头部前倾或侧歪趋势较为显著，颈椎排列偏移趋势较为明显，建议结合专业评估进一步确认，并进行系统性姿势干预。",
  "xiong-zhui-pai-lie-ji-ben-zheng-chang-wu-ming-xian-jie-gou-yi-chang": "胸椎排列基本正常，无明显结构异常",
  "xiong-zhui-pai-lie-qing-du-pian-yi-ke-neng-dui-sheng-huo-zhi-liang-you-qing-wei-ying-xiang": "胸椎排列略有偏移趋势，建议加强姿态管理。",
  "xiong-zhui-pai-lie-zhong-du-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "胸椎排列存在一定偏移，可能影响躯干姿态稳定性，建议进行针对性干预训练。",
  "xiong-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang-ke-neng-zao-cheng-teng-tong-ji-qi-ta-ji-fa-xing-wen-ti": "胸椎排列偏移趋势较为明显，躯干对称性下降，建议结合专业评估进行系统性姿势管理。",
  "yao-zhui-pai-lie-zheng-chang-zi-shi-ping-heng-wu-ming-xian-jie-gou-yi-chang": "腰椎排列正常，姿势平衡，无明显结构异常",
  "yao-zhui-pai-lie-qing-du-pian-yi-sheng-wu-li-xian-shang-ke-dan-chang-qi-ke-neng-yin-fa-zi-shi-dai-chang": "腰椎排列略有偏移趋势，当前整体姿态仍保持相对平衡，建议加强核心稳定训练。",
  "yao-zhui-pai-lie-zhong-du-pian-yi-sheng-wu-li-xian-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "腰椎排列存在一定偏移，姿态稳定性可能受到影响，建议进行针对性调整训练。",
  "yao-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang": "腰椎排列偏移趋势较为明显，建议结合专业评估并制定系统性姿势改善方案。",
  "jian-jia-ti-ji-xiong-suo-ru-tu-ji-he-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-jing-shen-qu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-jing-bu-ji-rou-bing-jin-hang-shen-zhan-yun-dong": '肩胛提肌、胸锁乳突肌及斜方肌上束<i class="IRed">参与度偏高</i>，颈深屈肌<i class="IBlue">参与度相对不足</i>。建议加强颈部稳定与颈深屈肌训练，并配合肩颈放松练习。',
  "zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolorred-jin-zhang-span-you-ce-xiong-suo-ru-tu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": '左侧胸锁乳突肌与后角斜角肌<i class="IRed">参与度偏高</i>，右侧胸锁乳突肌<i class="IBlue">参与度相对不足</i>。建议进行双侧平衡控制训练，并配合颈部放松练习。',
  "you-ce-xiong-suo-ru-tu-ji-span-stylecolorred-jin-zhang-span-zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": '右侧胸锁乳突肌<i class="IRed">参与度偏高</i>，左侧胸锁乳突肌与后角斜角肌<i class="IBlue">参与度相对不足</i>。建议进行对称性稳定训练，并配合颈部放松练习。',
  "zuo-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": '左侧斜方肌上束<i class="IRed">参与度偏高</i>，中下束<i class="IBlue">参与度相对不足</i>。建议加强斜方肌中下束控制训练，并配合上束放松练习。',
  "kuan-nei-xuan-ji-qun-he-nei-shou-ji-qun-span-stylecolorred-jin-zhang-span-tun-zhong-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-zhong-ji-la-shen-nei-shou-ji-qun": '髋内旋肌群与内收肌群<i class="IRed">参与度偏高</i>，臀中肌<i class="IBlue">参与度相对不足</i>。建议加强臀中肌稳定训练，并适度拉伸内收与内旋肌群。',
  "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-nei-shou-ji-qun-la-shen-tun-zhong-ji-he-li-zhuang-ji": '臀中肌与梨状肌<i class="IRed">参与度偏高</i>，髋内收肌群、内旋肌群及膝外侧副韧带稳定<i class="IBlue">参与度相对不足</i>。建议进行下肢整体稳定训练，并配合臀部放松练习。',
  "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-dan-ce-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-bao-chi-jun-heng-xun-lian-bi-mian-dan-ce-guo-du-shi-yong": '臀中肌与梨状肌<i class="IRed">参与度偏高</i>，单侧髋内收肌群、内旋肌群及膝外侧副韧带稳定<i class="IBlue">参与度相对不足</i>。建议加强双侧均衡训练，避免单侧过度使用。',
  "jian-yi-bao-chi-jun-heng-xun-lian-bi-mian-dan-ce-guo-du-shi-yong": "建议保持均衡训练，避免单侧过度使用。",
  "zuo-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": '左侧腘绳肌与膕肌<i class="IRed">参与度偏高</i>，股四头肌与比目鱼肌<i class="IBlue">参与度相对不足</i>。建议加强股四头肌与比目鱼肌训练，并适度拉伸腘绳肌与膕肌。',
  "zuo-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": '左侧股四头肌<i class="IRed">参与度偏高</i>，臀大肌与腘绳肌<i class="IBlue">参与度相对不足</i>。建议加强臀部主导训练与后侧链协同训练，并适度拉伸股四头肌。',
  "you-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": '右侧腘绳肌与膕肌<i class="IRed">参与度偏高</i>，股四头肌与比目鱼肌<i class="IBlue">参与度相对不足</i>。建议加强股四头肌与比目鱼肌训练，并适度拉伸腘绳肌与膕肌。',
  "you-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": '右侧股四头肌<i class="IRed">参与度偏高</i>，臀大肌与腘绳肌<i class="IBlue">参与度相对不足</i>。建议加强臀部主导训练与后侧链协同训练，并适度拉伸股四头肌。',
  "ji-zhu-jie-gou-qing-du-yi-chang-jian-yi-jia-qiang-zi-shi-guan-li-he-he-xin-ji-qun-xun-lian": "脊柱结构存在轻微偏离，建议关注日常姿势并加强核心肌群训练。",
  "ji-zhu-jie-gou-zhong-du-yi-chang-jian-yi-zhuan-ye-jiao-zheng-gan-yu-bing-ding-qi-fu-cha-ping-gu": "脊柱结构存在一定偏离，建议结合专业指导进行针对性训练与改善。",
  "ji-zhu-jie-gou-zhong-du-yi-chang-jian-yi-jiu-yi-jin-hang-duo-xue-ke-hui-zhen-ping-gu":"脊柱结构重度异常，建议就医进行多学科会诊评估。",
  "ji-rou-ping-gu-zheng-chang-qing-ji-xu-bao-chi-liang-hao-de-sheng-huo-xi-guan": "肌肉评估正常，请继续保持良好的生活习惯",
  "teng-tong-qian-zai-feng-xian-ping-gu": "疼痛潜在风险评估",
  "jing-bu": "颈部",
  "bei-bu": "背部",
  "yao-bu": "腰部",
  "jing-bu-zheng-ti-jie-gou-yi-chang-ping-fen": "颈部疼痛潜在风险评分",
  "bei-bu-zheng-ti-jie-gou-yi-chang-ping-fen": "背部疼痛潜在风险评分",
  "yao-bu-zheng-ti-jie-gou-yi-chang-ping-fen": "腰部疼痛潜在风险评分",
  "di-feng-xian": "低风险",
  "zhong-feng-xian": "中风险",
  "ji-zhu-jie-gou-ke-shi-hua": "脊柱结构可视化",
  "tuo-dong-xuan-zhuan-shi-tu": "拖动旋转视图",
  "ci-mo-xing-jin-gong-can-kao-shi-ji-ping-gu-yi-zhuan-ye-jian-ce-wei-zhun": "此模型仅供参考，实际评估以专业检测为准",
  "bei-mian": "背面",
  "zheng-shi-tu": "正视图",
  "you-shi-tu": "右视图",
  "hou-shi-tu": "后视图",
  "zuo-shi-tu": "左视图",
  "you-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": '右侧斜方肌上束<i class="IRed">参与度偏高</i>，中下束<i class="IBlue">参与度相对不足</i>。建议进行中下束稳定训练，并配合上束放松练习。',
  "tun-xing": "臀型",
  "dui-bi": "对比",
  "fang-xing-tun": "方形臀",
  "li-xing-tun": "梨形臀",
  "dao-san-jiao-xing-tun": "倒三角形臀",
  "yuan-xing-tun": "圆形臀",
  "jiao-li-xiang": "较理想",
  "mi-tao-tun": "蜜桃臀",
  "ben-ci": "本次",
  "li-shi": "历史",
  "ben-ci-li-shi": "本次、历史",
  "tun-wei": "臀围",
  "tun-xing-shuo-ming": "臀型说明",
  "tun-xing-shi-zhi-ren-ti-hou-bei-bu-yu-da-tui-zhi-jian-de-bu-wei-suo-xing-cheng-de-qu-xian-he-xing-zhuang-tun-xing-ping-gu-ke-yi-bang-zhu-ren-men-geng-hao-di-shi-xian-xing-xiang-guan-li-he-jian-kang-guan-mai": "臀型是指人体后背部与大腿之间的部位所形成的曲线和形状。臀型评估可以帮助人们更好地实现形象管理和健康管埋",
  "wo-zhi-dao-le": "我知道了",
  "fang-xing-tun-fang-xing-tun-shi-jue-gan-guan-shang-xia-yi-yang-kuan-tun-liang-ce-xian-tiao-jiao-zhi-mei-you-hu-du": "方形臀:方形臀视觉感官上下一样宽，臀两侧线条较直，没有弧度。",
  "yuan-xing-tun-shi-jue-gan-guan-xiang-yi-ge-yuan-xing-tun-bu-zhi-fang-fen-bu-jun-yun-yuan-run-bao-man-shi-fei-chang-li-xiang-de-tun-xing": "圆形臀:视觉感官像一个圆形，臀部脂肪分布均匀，圆润饱满，是非常理想的臀型。",
  "li-xing-tun-shi-jue-gan-guan-shang-zhai-xia-kuan-xia-tun-ji-rou-zhi-fang-fen-bu-jiao-duo-xian-tiao-bu-gou-feng-man": "梨形臀:视觉感官上窄下宽，下臀肌肉脂肪分布较多，线条不够丰满。",
  "dao-san-jiao-xing-tun-shi-jue-gan-guan-shang-kuan-xia-zhai-cheng-dao-san-jiao-xing": "倒三角形臀:视觉感官上宽下窄，呈倒三角形。",
  "mi-tao-tun-shi-jue-shang-xiang-yi-ge-mi-tao-xing-zhuang-tun-bu-xia-fang-feng-man-yao-bu-xian-xi-shi-fei-chang-li-xiang-de-tun-xing": "蜜桃臀:视觉上像一个“蜜桃”形状，臀部下方丰满，腰部纤细，是非常理想的臀型。",
  "zan-wu-mo-xing": "暂无模型",
  "ce-liang": "测量",
  "ben-ci-ce-liang": "本次测量",
  "ben-ci-ce-liang-wei-he-cheng-cheng-gong-ke-dao-she-bei-zai-ci-ce-liang": "本次测量未合成成功，可到设备再次测量",
  "gai-ri-qi-wu-mo-xing-qing-xuan-ze-qi-ta-dui-bi-ri-qi": "该日期无模型，请选择其他对比日期",
  "shou-ci-ce-liang-zan-wu-li-shi-shu-ju": "首次测量，暂无历史数据",
  "mo-xing-jia-zai-shi-bai-qing-shua-xin-ye-mian-chang-shi-yi-xia": "模型加载失败，请刷新页面尝试一下",
  "jing-zhui-7": "颈椎7",
  "di-gu-zhong-dian": "骶骨中点",
  "di-gu-hou-shang-jiao": "骶骨后上角",
  "ren-ti-zhong-xin": "人体重心",
  "spine-tips1":"本报告仅供参考，不作为医疗诊断依据。建议结合医生意见进行综合评估。",
  "spine-tips2": "2025 Visbody 脊柱专项评估系统",
  'tun-xing-ping-gu': '臀型评估',
  "yi-xia-shi-nin-de-tun-xing-lei-xing":"以下是您的臀型类型",
  "qi-ta-tun-xing": "其他臀型",
  "ji-zhu-ping-gu": "脊柱评估",
  "qing-shao-nian-ji-zhu-zhuan-xiang-feng-xian-ping-gu":"青少年脊柱专项风险评估",
  "qing-shao-nian-ji-zhu-fa-yu-zhi-shu": "青少年脊柱发育指数",
  "xue-xi-zi-shi-fu-he-zhi-shu": "学习姿势负荷指数",
  "gu-ge-ping-heng-zhi-shu":"骨骼平衡指数",
  "sheng-chang-qi-teng-tong-yu-jing-zhi-shu": "生长期痛症预警指数",
  "ji-zhu-ce-wan-feng-xian-ping-fen": "脊柱侧弯风险评分",
  "qia-yao-ji-shu-ji-ji":"髂腰肌/竖脊肌",
  "xia-bu-jin-zhang-fu-heng-ji-bao-ruo":"下部紧张 、腹横肌薄弱",
  "ji-zhu-fa-yu-zheng-chang-wu-ming-xian-jie-gou-wen-ti":"脊柱发育正常，无明显结构问题",
  "cun-zai-qing-wei-fa-yu-yin-huan-jian-yi-gai-shan-zi-shi-xi-guan":"存在轻微发育隐患，建议改善姿势习惯",
  "zhong-du-fa-yu-feng-xian":"中度发育风险",
  "yan-zhong-ying-xiang-ji-zhu-fa-yu":"严重影响脊柱发育",
  "xue-xi-zi-shi-liang-hao-ke-chang-shi-jian-wei-chi":"学习姿势良好，可长时间维持",
  "zi-shi-you-dai-gai-shan-jian-yi-mei-45-fen-zhong-xiu-xi":"姿势有待改善，建议每45分钟休息",
  "cun-zai-ming-xian-zi-shi-wen-ti-xu-yao-ding-qi-la-shen":"存在明显姿势问题，需要定期拉伸",
  "xue-xi-zi-shi-yan-zhong-bu-liang-huo-jiang-ying-xiang-xue-xi-xiao-shuai-he-fa-yu":"学习姿势严重不良，或将影响学习效率和发育",
  "gu-ge-fa-yu-dui-cheng-zi-shi-wen-ding":"骨骼发育对称，姿势稳定",
  "cun-zai-qing-wei-bu-dui-cheng-jian-yi-jian-ce":"存在轻微不对称，建议监测",
  "fa-yu-bu-jun-yun-xu-yao-jiu-zheng-cuo-shi":"发育不均匀，需要纠正措施",
  "gu-ge-fa-yu-yan-zhong-bu-dui-cheng-ying-xiang-sheng-chang":"骨骼发育严重不对称，影响生长",
  "zi-shi-liang-hao-teng-tong-feng-xian-di":"姿势良好，疼痛风险低",
  "qing-du-teng-tong-feng-xian-jian-yi-zi-shi-guan-li":"轻度疼痛风险，建议姿势管理",
  "zhong-du-teng-tong-feng-xian-xu-zhuan-ye-zhi-dao":"中度疼痛风险，需专业指导",
  "gao-du-teng-tong-feng-xian-ke-neng-yi-you-bu-shi-gan":"高度疼痛风险，可能已有不适感",
  "di-feng-xian-qing-bao-chi-liang-hao-zi-shi-xi-guan":"低风险，请保持良好姿势习惯",
  "zhong-feng-xian-ke-neng-xu-yao-jin-yi-bu-guan-cha-huo-gan-yu":"中风险，可能需要进一步观察或干预",
  "gao-feng-xian-xu-yao-ji-shi-jiu-yi-jin-hang-zhuan-ye-yi-liao-ping-gu-gan-yu":"高风险，需要及时就医进行专业医疗评估干预",
  "you-liang":"优良",
  "zhu-yi":"注意",
  "gan-yu":"干预",
  "jing-shi":"警示",
  "di-fu-he":"低负荷",
  "zhong-fu-he":"中负荷",
  "gao-fu-he":"高负荷",
  "guo-zai":"过载",
  "ping-heng-xing":"平衡型",
  "qing-du-bu-ping-heng":"轻度不平衡",
  "zhong-du-bu-ping-heng":"中度不平衡",
  "yan-zhong-bu-ping-heng":"严重不平衡",
  "an-quan":"安全",
  "wei-xian":"危险",
  "wu-yi-chang": "无异常",
   balanceReport: {
        scoreUnit: '分',
        compareLast: '对比上次',
        status: {
            excellent: '优秀',
            good: '良好',
            medium: '中等',
            fair: '一般',
            poor: '较差'
        },
        levelDesc: [
            '优秀',
            '良好',
            '一般',
            '较差'
        ],
        systemEvaluation: '感官系统评价',
        visualEvaluation: '视觉感官评价',
        evaluationLevel: '评价等级',
        unit: '单位：',
        swayRms: '晃动程度',
        eyeCloseTest: '闭眼静态平衡',
        copArea: 'COP 轨迹面积',
        avgSpeed: '平均速度',
        maxDisplacement: '最大偏移',
        centerTrajectory: '重心位移轨迹',
        eyeOpenTest: '睁眼静态平衡',
        last: '上次 ',
        conclusion: {
            eyeClose: {
                level1: '您的闭眼静态平衡能力处于优秀水平（A级），本体感觉 - 前庭功能整合高效，无视觉输入仍能通过内在感觉维持稳定，在黑暗环境（如夜间起床、关灯后行走）中可活动自如',
                level2: '您的闭眼静态平衡能力处于良好水平（B级），本体感觉代偿能力良好，视觉消失后可调整重心，日常闭眼动作可正常完成，仅突然闭眼时需短暂调整',
                level3: '您的闭眼静态平衡能力处于相对一般（C级），本体感觉或前庭功能较差，晃动幅度相对较大，在无视觉辅助场景（如暗室、闭眼捡物）中易头晕不稳，需依赖支撑物降低风险',
                level4: '您的闭眼静态平衡能力差（D级），可能存在神经或本体感觉系统障碍，无视觉辅助时难以维持平衡，黑暗环境中跌倒风险显著升高'
            },
            eyeOpen: {
                level1: '您的睁眼静态平衡能力处于优秀水平（A级），视觉 - 躯体整合效率高，站姿稳定且能耗低，在复杂环境（如不平路面、人流拥挤处）行走站立不易失衡，适应环境变化能力突出。',
                level2: '您的睁眼静态平衡能力良好（B级），重心调控以视觉反馈为主、本体感觉辅助，日常站立行走无明显困难，在单一视觉环境中表现稳定。',
                level3: '您的睁眼静态平衡能力一般（C级），站姿控制较不稳定，通过视觉调控重心平衡的能力不足，在视觉干扰环境（如强光、快速移动背景）中易不稳，长时间站立需频繁调整姿势。',
                level4: '您的睁眼静态平衡能力差（D级），站姿存在明显晃动，通过视觉调控重心平衡的能力差，可能存在视觉 - 前庭 - 本体觉整合障碍，日常活动（如上下楼梯、过马路）中平衡稳定性差，跌倒风险升高。'
            }
        },
        levelStatus: {
            A: 'A级',
            B: 'B级',
            C: 'C级',
            D: 'D级'
        },
        chart: {
            eyeCloseTest: '闭眼站立测试',
            eyeOpenTest: '睁眼站立测试',
            yAxisLabels: ['低', '中', '高']
        },
        selectionRport: "选择一份报告对比",
        measureDes: "项目测量明细",
        balanceTittle: "平衡评估",
        pingDes: "评价等级：优秀、良好、一般、较差"
    },
  "neckReport": {
  "title": "颈部功能",
  "conclusion": "颈部功能评估",
  "loading": "报告合成中",
  "failed": "报告合成失败",
  "analysis": "分析",
  "suggestion": "建议",
  "suggestionText": "找专业人士对具体原因做进一步筛查及治疗"
}
}
